module.exports = __webpack_public_path__ + "media/images/menu-btn-c5871fb8486fdcaa62f71e1f1b9c3b9f.svg";